'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('../../SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DeviceBatteryCharging30 = function DeviceBatteryCharging30(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z' }),
    _react2.default.createElement('path', { d: 'M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z' })
  );
};
DeviceBatteryCharging30 = (0, _pure2.default)(DeviceBatteryCharging30);
DeviceBatteryCharging30.displayName = 'DeviceBatteryCharging30';
DeviceBatteryCharging30.muiName = 'SvgIcon';

exports.default = DeviceBatteryCharging30;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui/svg-icons/device/battery-charging-30.js
// module id = 2144
// module chunks = 0